import client from "../../../api/client";
import mapRegisterPayload from "../utils/mapRegisterPayload";

export default async function registerUser(values) {
  const payload = mapRegisterPayload(values);

  const response = await client.post("/auth/register", payload);
  return response.data;
}